import { defineMessages } from "react-intl";
const messages = defineMessages({
    analyticsPermissionLabel: {
        id: "app.users.createUser.analytics.label.text",
        defaultMessage: "Select analytics permission",
    },
    analyticsPermissionOptionView: {
        id: "app.users.createUser.analytics.option.view.text",
        defaultMessage: "View",
    },
    analyticsPermissionOptionDeny: {
        id: "app.users.createUser.analytics.option.deny.text",
        defaultMessage: "No Access",
    },
});
export default messages;
